import { useQuery } from '@tanstack/react-query';
import { useFetch } from '@/hooks/useFetch';
import type { GetImportantDatesResponse } from '@/types/clientDetailsApiTypes';

export const IMPORTANT_DATES_BY_CLIENT_QUERY_KEY = 'important-dates-by-client';

export interface GetImportantDatesByClientParams {
  clientId: number | null | undefined;
  /** Optional filters per API #1 */
  name?: string;
  eventDateFrom?: string;
  eventDateTo?: string;
  notes?: string;
}

function buildQueryString(params: GetImportantDatesByClientParams): string {
  const search = new URLSearchParams();
  if (params.name != null && params.name !== '') search.set('name', params.name);
  if (params.eventDateFrom != null && params.eventDateFrom !== '')
    search.set('eventDateFrom', params.eventDateFrom);
  if (params.eventDateTo != null && params.eventDateTo !== '')
    search.set('eventDateTo', params.eventDateTo);
  if (params.notes != null && params.notes !== '') search.set('notes', params.notes);
  const qs = search.toString();
  return qs ? `?${qs}` : '';
}

export function useGetImportantDatesByClientQuery(
  params: GetImportantDatesByClientParams
) {
  const { clientId, ...filterParams } = params;
  const { doFetch: getImportantDates } = useFetch<void, GetImportantDatesResponse>();
  const queryString = buildQueryString({ ...params, clientId: undefined });

  return useQuery({
    queryKey: [IMPORTANT_DATES_BY_CLIENT_QUERY_KEY, clientId, filterParams],
    queryFn: async (): Promise<GetImportantDatesResponse> => {
      if (clientId == null || clientId === 0) {
        return { success: true, message: '', data: [] };
      }
      return getImportantDates(
        `/api/important-dates/client/${clientId}${queryString}`
      );
    },
    enabled: clientId != null && clientId > 0,
  });
}
